import React from 'react';
import { Drawer, Radio } from 'antd';

export const SORT_OPTIONS: { field: string; order: 'ASC' | 'DESC'; label: string }[] = [
  { field: 'priceCents', order: 'ASC', label: 'Preis (aufsteigend)' },
  { field: 'priceCents', order: 'DESC', label: 'Preis (absteigend)' },
  { field: 'createdAt', order: 'DESC', label: 'Neueste zuerst' },
  { field: 'createdAt', order: 'ASC', label: 'Älteste zuerst' },
  { field: 'brand', order: 'ASC', label: 'Marke (A–Z)' },
  { field: 'brand', order: 'DESC', label: 'Marke (Z–A)' },
  { field: 'model', order: 'ASC', label: 'Modell (A–Z)' },
  { field: 'model', order: 'DESC', label: 'Modell (Z–A)' },
  { field: 'sku', order: 'ASC', label: 'SKU (aufsteigend)' },
  { field: 'sku', order: 'DESC', label: 'SKU (absteigend)' },
];

interface ProductSortSheetProps {
  open: boolean;
  sortField: string;
  sortOrder: 'ASC' | 'DESC';
  onClose: () => void;
  onChange: (field: string, order: 'ASC' | 'DESC') => void;
}

const ProductSortSheet: React.FC<ProductSortSheetProps> = ({ open, sortField, sortOrder, onClose, onChange }) => (
  <Drawer
    placement="bottom"
    open={open}
    onClose={onClose}
    title="Sortieren nach"
    size="auto"
    styles={{ wrapper: { maxHeight: '85vh', borderRadius: '16px 16px 0 0', overflow: 'hidden' } }}
  >
    <Radio.Group
      value={`${sortField}:${sortOrder}`}
      onChange={(e) => {
        const [field, order] = String(e.target.value).split(':');
        onChange(field, order as 'ASC' | 'DESC');
      }}
      style={{ display: 'flex', flexDirection: 'column', paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-sort-options"
    >
      {SORT_OPTIONS.map(({ field, order, label }) => (
        <Radio key={`${field}:${order}`} value={`${field}:${order}`} style={{ minHeight: 44, alignItems: 'center' }}>
          {label}
        </Radio>
      ))}
    </Radio.Group>
  </Drawer>
);

export default ProductSortSheet;
